import { render, staticRenderFns } from "./ModalSavedReport.vue?vue&type=template&id=63f38481&"
import script from "./ModalSavedReport.vue?vue&type=script&lang=js&"
export * from "./ModalSavedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports